import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import { Create } from "../../../utils/apis/teen_patti/teen_patti_amount/index";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS } from "../../../utils/common";
import { Context } from "../../../utils/context";
import Select from "react-select";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import Loader from "react-js-loader";
function Add(props) {
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const { UnauthorizedLogOut } = useContext(Context);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    watch,
    control,
  } = useForm();
  const imageFile = watch("image");
  const [shimmerLoader, setShimmerLoader] = useState(false);
  const onSubmit = async (data) => {
    setShimmerLoader(true);
    try {
      const sendData = new FormData();
      sendData.append("amount", data?.amount);
      const response = await Create(sendData);

      if (HTTPS.ALREADY_REPORTED.code !== response?.data?.code) {
        setShimmerLoader(false);
        await setShowModal({
          code: response.data.code,
          message: response.data.data,
        });
        setTimeout(() => {
          setShowModal(0);
          props.onHide();
          reset();
        }, 2000);
      } else {
        setShimmerLoader(false);
        setError("name", {
          type: "manual",
          message: response?.data?.errors || "An error occurred",
        });
      }
    } catch (error) {
      setError("name", {
        type: "manual", // Optional but helps to indicate it's a manual error
        message: error?.response?.data?.errors,
      });
      await UnauthorizedLogOut(error);
      console.error(error);
    }
  };

  const [UsersType, setUsersType] = useState([
    {
      value: "customers",
      label: "customers",
      name: "users_type",
    },
    {
      value: "agents",
      label: "agents",
      name: "users_type",
    },
  ]);
  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="mg"
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <Modal_Heading modalHeading={"Add Teen Patti Table Amount"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="row">
                      <div className="row">
                        <div className="col-md-12 col-sm-12 mt-3">
                          <Form.Group
                            className="form-field"
                            controlId="formBasicEmail">
                            <Form.Label>Amount*</Form.Label>
                            <Form.Control
                              type="number"
                              name="amount"
                              placeholder="Amount"
                              className={classNames("", {
                                "is-invalid": errors?.amount,
                              })}
                              {...register("amount", {
                                required: "Amount is required",
                              })}
                            />
                            {errors.amount && (
                              <span className="text-danger">
                                {errors.amount.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      className="search-btn mx-2"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}>
                      Cancel
                    </Button>

                    {shimmerLoader ? (
                      <Loader
                        type="bubble-top"
                        bgColor={"#FFF"} // Background color set to white
                        color={"#FFF"}
                        size={50}
                      />
                    ) : (
                      <Button
                        className="reset-btn mx-2"
                        type="button"
                        onClick={handleSubmit(onSubmit)}>
                        Submit
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />

        {/* <Successfull_Modal
        message={"abc"}
        subMessage={"xyz"}
          show={modalShow}
          onHide={() => setModalShow(false)}
        /> */}
      </section>
    </>
  );
}

export default Add;
